module.exports = __webpack_public_path__ + "img/container-green.fdc3e93f.svg";